import { Component, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { Base } from '../common/base';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PoblacionService } from '../../services/poblacion/poblacion.service';
import { StorageService } from '../../utils/util.storage.service';
import { of, concatMap, } from 'rxjs';
import { UserLoggedResponse, UserRolResponde } from '../../models/user';
import { ConsultaPoblacionActivosModel, ConsultaPoblacionContratosCarteraModel, ConsultaPoblacionRetiradosModel } from '../../models/poblacion/mi-poblacion';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { UtilFormat } from '../../utils/format';
import { TrackData } from '../../models/app-track/track-data.model';
const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8";
const EXCEL_EXT = ".xlsx";

@Component({
  selector: 'app-consulta-poblacion',
  templateUrl: './consultaPoblacion.component.html',
  styleUrls: ['./consultaPoblacion.component.css']
})
export class ConsultaPoblacionComponent extends Base {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  public frmMain: FormGroup = new FormGroup({});
  public frmContratos: FormGroup = new FormGroup({});
  public frmActivos: FormGroup = new FormGroup({});
  lockExport = true;  
  edadCarteraData: any[] = [];
  parentescoData: any[] = [];
  generoData: any[] = [];
  programaData: any[] = [];
  rangoEdadData: any[] = [];

  haveDataToShow: boolean = false;
  haveResponde: boolean = false;
  generalMessage: string = "";
  jsonRespuesta: any = [];

  attrData: string[] = [];
  attrDataExport: string[] = [];
  namesColumns: string[] = [];
  namesColumnsExport: string[] = [];
  mandatoryColumns = ['identificacion', 'nombre'];
  

  dpContratos: string[] = ['identificacion', 'nombre','Linea', 'Plan', 'Programa', 'FECHA_INICIO_SERVICIO', 'Inicio_Servicio', 'FECHA_ANTIGUEDAD', 'Antiguedad', 'Contrato', 'Numerousuario', 'Corte', 'Diasmora', 'Valormora', 'PERIODOS_VENCIDOS', 'Cartera', 'Telefono', 'Email'];
  namesContratos: string[] = ['Identificación', 'Nombre y Apellidos Titular', 'Línea de negocio', 'Plan', 'Programa', 'Fecha Inicio servicio', 'Inicio Servicio', 'Fecha Antiguedad', 'Antiguedad', 'Número contrato', 'Número usuarios', 'Fecha corte', 'Días Vencidos', 'Saldo Adeudado (más IVA)', 'Períodos vencidos', 'Nro. Cuotas Vencidas', 'Teléfono Celular', 'E-mail'];
  dpActivos: string[] = ['identificacion', 'nombre', 'Estado', 'UsuarioConServicio', 'FechaIniServ', 'Fecha_Antiguedad', 'Parentesco_Real', 'Contrato', 'Programa', 'Corte', 'Cartera', 'Telefono', 'Email'];
  namesActivos: string[] = ['Identificación', 'Nombre y Apellidos', 'Estado', 'Usuario con servicio', 'Fecha inicio servicio', 'Fecha antigüedad', 'Parentesco real', 'Número contrato', 'Programa', 'Corte', 'Cuotas Vencidas', 'Teléfono Celular', 'E-mail'];
  dpRetirados: string[] = ['identificacion', 'nombre', 'estado', 'ParentescoReal', 'Contrato', 'Programa', 'fecharetiro', 'motivoretiro', 'Telefono', 'Email'];
  namesRetirados: string[] = ['Identificación', 'Nombre y Apellidos Contratante', 'Estado', 'Parentesco real', 'Número contrato', 'Programa', 'Fecha retiro', 'Motivo retiro', 'Teléfono Celular', 'E-mail'];
  columnOptions = [
    { key: 'todas', label: 'Todas', selected: true },
    { key: 'identificacion', label: 'Identificación', selected: true },
    { key: 'nombre', label: 'Nombre y Apellidos Titular', selected: true },
    { key: 'Linea', label: 'Línea de negocio', selected: true },
    { key: 'Plan', label: 'Plan', selected: true },
    { key: 'Programa', label: 'Programa', selected: true },
    { key: 'FECHA_INICIO_SERVICIO', label: 'Fecha Inicio servicio', selected: true },
    { key: 'Inicio_Servicio', label: 'Inicio Servicio', selected: true },
    { key: 'FECHA_ANTIGUEDAD', label: 'Fecha Antiguedad', selected: true },
    { key: 'Antiguedad', label: 'Antiguedad', selected: true },
    { key: 'Contrato', label: 'Número contrato', selected: true },
    { key: 'Numerousuario', label: 'Número usuarios', selected: true },
    { key: 'Corte', label: 'Fecha corte', selected: true },
    { key: 'Diasmora', label: 'Días Vencidos', selected: true },
    { key: 'Valormora', label: 'Saldo Adeudado (más IVA)', selected: true },
    { key: 'PERIODOS_VENCIDOS', label: 'Períodos vencidos', selected: true },
    { key: 'Cartera', label: 'Nro. Cuotas Vencidas', selected: true },
    { key: 'Telefono', label: 'Teléfono Celular', selected: true },
    { key: 'Email', label: 'E-mail', selected: true },
  ];

  dpContratosReporte: string[] = [
    'Contrato',
    'Numerousuario',
    'Corte',
    'ModalidadPago',
    'sucursal',
    'regional',
    'identificacion',
    'nombre',
    'Linea',
    'Plan',
    'Programa',
    'FECHA_INICIO_SERVICIO',
    'Inicio_Servicio',
    'FECHA_ANTIGUEDAD',
    'Antiguedad',
    'AsesorPoblacion',
    'AsesorGestion',    
    'Diasmora',
    'Cartera',
    'SaldoNoVencido',
    'SaldoAdeudado',
    'PERIODOS_VENCIDOS',
    'Telefono', 
    'Email'
  ];
  namesContratosReporte: string[] = [
    'Contrato',
    'Numero Usuarios',
    'Fecha Corte',
    'Pre o Postpago',
    'Sucursal',
    'Regional',
    'Identificación',
    'Nombre y Apellidos Titular',
    'Línea de negocio',
    'Plan',
    'Programa',
    'Fecha Inicio servicio',
    'Inicio Servicio',
    'Fecha Antiguedad',
    'Antigüedad',
    'Asesor Población',
    'Asesor Gestión',
    'Días Vencidos',
    'Nro. Cuotas Vencidas',
    'Saldo No Vencido (más IVA)',
    'Saldo Adeudado (más IVA)',
    'Períodos vencidos',
    'Teléfono Celular',
    'E-mail'
  ];
  dpActivosReporte: string[] = [
    'identificacion',
    'nombre',
    'Fecha_Naci_Usua',    
    'Parentesco_Real',
    'Grupo_Etareo',
    'Email',
    'Direccion_Usuario',
    'Telefono',
    'Estado',
    'UsuarioConServicio',
    'FechaIniServ',
    'Fecha_Antiguedad',
    'Linea',
    'Programa',
    'Plan',
    'Cuenta',
    'Subcuenta',
    'CodigoCampaña',
    'NombreCampaña',
    'Contrato',
    'Corte',
    'ModalidadPago',
    'Sucursal',
    'Regional',
    'CuotaReal',
    'CuotaRealmasiva',
    'NumContratante',
    'NombreContratante',    
    'AsesorPoblacion',
    'AsesorGestion',
    'Cartera',
  ];
  namesActivosReporte: string[] = [
    'Identificación Usuario',
    'Nombre y Apellidos Usuario',
    'Fecha Nacimiento',    
    'Parentesco Real',
    'Grupo Etareo',
    'Email',
    'Dirección',
    'Teléfono',
    'Estado',
    'Usuario con Servicio',
    'Inicio servicio',
    'Antigüedad',
    'Línea',
    'Programa',    
    'Plan',
    'Cuenta',
    'Subcuenta',
    'Campaña',
    'Descripción campaña',
    'Contrato',
    'Fecha Corte',
    'Pre o Postpago',
    'Sucursal',
    'Regional',
    'Cuota',
    'Cuota real más IVA',
    'Identificación Contratante',
    'Nombre Contratante',    
    'Asesor Población',
    'Asesor Gestión',
    'Cartera',
  ];
  dsConsultaPoblacion!: MatTableDataSource<any>;
  selectedOption = 0;
  userCC!: UserLoggedResponse;
  role!: UserRolResponde[];
  jsonData: any;
  reporteSeleccionadoName = "";
  trackData!: TrackData;
  lineasSeleccionadas: any[] = [];
  programasSeleccionados: any[] = [];
  planesSeleccionados:any[] = [];
  contratantesSeleccionados: any[] = [];
  identificacionesSeleccionadas: any[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private matDialog: MatDialog,
    private spinner: NgxSpinnerService,
    private mainCmp: MaincontainerComponent,
    private poblacionService: PoblacionService,
    private storageService: StorageService,
  ) {
    super();
    this.buildForm();
    this.loadParametersRecursive();
    
    this.attrData = this.dpContratos;
    this.namesColumns = this.namesContratos;
    this.haveResponde = true;
    this.dsConsultaPoblacion = new MatTableDataSource();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle("CONSULTA MI POBLACIÓN");
    });
    this.userCC = this.storageService.getItem('user') ?? 'Document no esta llegando';
    this.role = this.userCC.roles;

    
    this.dsConsultaPoblacion.paginator = this.paginator;
    this.dsConsultaPoblacion.sort = this.sort;
  }

  private buildForm(): void {
    this.frmMain = this._formBuilder.group({
      selectedOption: ['',Validators.required]
    });

    this.frmContratos = this._formBuilder.group({
      walletAge: [null,[ ]],
    });

    this.frmActivos = this._formBuilder.group({
      ageRange: ["",[ ]],
      kinship: ["",[ ]],
      gender: ["",[ ]],
      program: ["",[ ]],
    });
  }

  onSelectionChange(event: any) {
    this.generalMessage = "";
    this.selectedOption = this.frmMain.value.selectedOption;
    this.frmContratos.get('walletAge')?.setValidators([]);
    this.frmContratos.get('walletAge')?.updateValueAndValidity();
    this.dsConsultaPoblacion = new MatTableDataSource();
    this.haveDataToShow = false;
    if(this.selectedOption == 1){ //1 edad cartera
      this.frmContratos.get('walletAge')?.setValidators([Validators.required]);
      this.frmContratos.get('walletAge')?.updateValueAndValidity();
      this.attrData = this.dpContratos;
      this.attrDataExport = this.dpContratosReporte;
      this.namesColumns = this.namesContratos;
      this.namesColumnsExport = this.namesContratosReporte;
      this.lockExport = false;
      this.reporteSeleccionadoName = "Contratos Cartera";
    }else if(this.selectedOption == 2){ //activos 
      this.attrData = this.dpActivos;
      this.attrDataExport = this.dpActivosReporte;
      this.namesColumns = this.namesActivos;
      this.namesColumnsExport = this.namesActivosReporte;
      this.lockExport = false;
      this.reporteSeleccionadoName = "Usuarios Activos";
    }else{ //3 retirados
      this.attrData = this.dpRetirados;
      this.attrDataExport = [];
      this.namesColumns = this.namesRetirados;
      this.namesColumnsExport = [];
      this.lockExport = true;
      this.reporteSeleccionadoName = "Usuarios Retirados";
    }
  }

  consultar() {
    if (this.frmMain.valid) {
      if (this.selectedOption == 1 && this.frmContratos.valid) {
        // Primero consulta activos para cargar datos necesarios
        this.resetColumnsToMandatory();

        this.consultarActivos().add(() => {
          // Cuando termine consultarActivos, llamar a consultarEdadCartera
          this.consultarEdadCartera();
        });
      } else if (this.selectedOption == 2 && this.frmActivos.valid) {
        this.consultarActivos();
      } else if (this.selectedOption == 3) {
        this.consultarRetirados();
      } else {
        this.generalMessage = "Debe completar los campos requeridos.";
      }
    } else {
      this.generalMessage = "Debe seleccionar una opción.";
    }
  }

  resetColumnsToMandatory() {
    // Marcar solo las obligatorias como seleccionadas
    this.columnOptions.forEach(col => {
      col.selected = this.mandatoryColumns.includes(col.key);
    });

    // Actualizar las columnas visibles en tabla
    this.displayedColumns = [...this.mandatoryColumns];
    this.attrData = [...this.mandatoryColumns];

    // Actualizar los nombres también
    this.namesColumns = this.columnOptions
      .filter(c => this.mandatoryColumns.includes(c.key))
      .map(c => c.label);
  }

  consultarEdadCartera(){
    this.spinner.show();    
    let json = {
      identificationAsesor: this.deleteSpaceAsesor(this.userCC.document),
      typeAsesor: this.role[0].claveRol,
      cuota: this.frmContratos.get('walletAge')?.value.toString()
    };
    
    this.poblacionService.consultPoblacionEdadCartera(json).subscribe({
      next: response => {
        this.spinner.hide();   
        if (response.data.length != 0) {
          this.haveResponde = true;
          this.haveDataToShow = true;
          console.log("Data de Cartera", response);
          const dataMaped: ConsultaPoblacionContratosCarteraModel[] = response.data.map( (item: { FECHA_INICIO_SERVICIO:any, FECHA_ANTIGUEDAD:any, Cartera:any, Valormora: any; SaldoAdeudado: any; SaldoNoVencido: any; SaldoVencido: any; PERIODOS_VENCIDOS:any; identificacion: any; Inicio_Servicio:any; Antiguedad: any; }, index:number) => {
          const periodosVencidos = this.generarPeriodosVencidos(item.Cartera);

          const idLimpio = item.identificacion.replace(/\D/g, "").trim();
          index = this.identificacionesSeleccionadas.indexOf(idLimpio);

            return { ...item, 
              Linea: this.lineasSeleccionadas[index] || '',
              Programa: this.programasSeleccionados[index] || '',
              Plan: this.planesSeleccionados[index] || '',
              FECHA_INICIO_SERVICIO: item.FECHA_INICIO_SERVICIO,
              FECHA_ANTIGUEDAD: item.FECHA_ANTIGUEDAD,
              Inicio_Servicio: this.calcularDiferenciaDias(item.FECHA_INICIO_SERVICIO),
              Antiguedad: this.calcularDiferenciaDias(item.FECHA_ANTIGUEDAD),
              Valormora: UtilFormat.formatMoney(item.Valormora), 
              SaldoAdeudado: UtilFormat.formatMoney(item.SaldoAdeudado), 
              SaldoNoVencido: UtilFormat.formatMoney(item.SaldoNoVencido), 
              SaldoVencido: UtilFormat.formatMoney(item.SaldoVencido),
              PERIODOS_VENCIDOS: periodosVencidos};
          });

          this.dsConsultaPoblacion = new MatTableDataSource(dataMaped);
          this.jsonData = dataMaped;
          this.columnOptions = this.columnOptions.map(c => ({
            ...c,
            selected: this.mandatoryColumns.includes(c.key) ? true : false
          }));

          const selectedKeys = this.columnOptions
            .filter(c => c.selected)
            .map(c => c.key);
            
          this.displayedColumns = [...selectedKeys];
          this.attrData = [...selectedKeys];

          this.namesColumns = this.columnOptions
            .filter(c => c.selected)
            .map(c => c.label);
          this.dsConsultaPoblacion.paginator = this.paginator;
          this.dsConsultaPoblacion.sort = this.sort;
        } else {
          this.haveResponde = true;
          this.haveDataToShow = false;
          this.generalMessage = "Sin información.";          
        }
      },
      error: error => {
        this.spinner.hide();
        this.haveResponde = false;
        this.haveDataToShow = false;
        this.showMessageDialog("Error", "Ocurrió un error al consultar.", "Aceptar", "", true, 3, this.matDialog, (_: any) => { });
      }
    });
  }

  consultarActivos() {
    this.spinner.show();
    const json = {
      identificationAsesor: this.deleteSpaceAsesor(this.userCC.document),
      typeAsesor: this.role[0].claveRol,
      genero: this.frmActivos.get('gender')?.value?.toString() || "",
      parentesco: this.frmActivos.get('kinship')?.value?.toString() || "",
      programa: this.frmActivos.get('program')?.value?.toString() || "",
      edad: this.frmActivos.get('ageRange')?.value?.toString() || ""
    };

    return this.poblacionService.consultPoblacionActivos(json).subscribe({
      next: (response) => {
        this.spinner.hide();
        const filterData = response.data.find(
          (item: { CuotaReal: any; CuotaRealmasiva: any }) =>
            item.CuotaReal == null && item.CuotaRealmasiva == null
        );

        if (response?.data?.length) {
          console.log("Data de Activos", response);
          this.haveResponde = true;
          this.haveDataToShow = true;

          this.identificacionesSeleccionadas = response.data.map((item: any) => 
            (item.NumContratante 
              ? item.NumContratante.replace(/\D/g, "").trim() 
              : item.identificacion.replace(/\D/g, "").trim())
          );
          this.lineasSeleccionadas = response.data.map((item: any) => item.Linea);
          this.programasSeleccionados = response.data.map((item: any) => item.Programa);
          this.planesSeleccionados = response.data.map((item: any) => item.Plan);

          const dataMaped: ConsultaPoblacionActivosModel[] = response.data.map(
            (item: { CuotaReal: any; CuotaRealmasiva: any }) => ({
              ...item,
              CuotaReal: item.CuotaReal ? UtilFormat.formatMoney(item.CuotaReal) : 0,
              CuotaRealmasiva: item.CuotaRealmasiva
                ? UtilFormat.formatMoney(item.CuotaRealmasiva)
                : 0,
            })
          );

          this.dsConsultaPoblacion = new MatTableDataSource(dataMaped);
          this.jsonData = dataMaped;
          this.dsConsultaPoblacion.paginator = this.paginator;
          this.dsConsultaPoblacion.sort = this.sort;
        } else {
          this.haveResponde = true;
          this.haveDataToShow = false;
          this.generalMessage = "Sin información.";
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.haveResponde = false;
        this.haveDataToShow = false;
        this.showMessageDialog(
          "Error",
          "Ocurrió un error al consultar.",
          "Aceptar",
          "",
          true,
          3,
          this.matDialog,
          (_: any) => {}
        );
      },
    });
  }

  private generarPeriodosVencidos(numCuotas: number): string {
    if (!numCuotas || numCuotas <= 0) 
      return "";

    const meses = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    const hoy = new Date();
    const periodos: string[] = []; 
    
    for (let i = numCuotas - 1; i >= 0; i--) {
      const fecha = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
      const nombreMes = meses[fecha.getMonth()];
      periodos.push(nombreMes);
    }

    return periodos.join(", ");
  }

  limpiarIdentificacion(ident: string): string {
    if (!ident) return "";
    return ident.replace(/[A-Za-z\- ]/g, "").trim();
  }

  consultarRetirados(){
    this.spinner.show();    
    let json = {
      identificationAsesor: this.deleteSpaceAsesor(this.userCC.document),
      typeAsesor: this.role[0].claveRol
    };
    
    this.poblacionService.consultPoblacionRetirados(json).subscribe({
      next: response => {
        this.spinner.hide();        
        if (response.data.length != 0) {
          this.haveResponde = true;
          this.haveDataToShow = true;
          const dataMaped: ConsultaPoblacionRetiradosModel[] = response.data;
          this.dsConsultaPoblacion = new MatTableDataSource(dataMaped);
          this.jsonData = dataMaped;
          this.dsConsultaPoblacion.paginator = this.paginator;
          this.dsConsultaPoblacion.sort = this.sort;
        } else {
          this.haveResponde = true;
          this.haveDataToShow = false;
          this.generalMessage = "Sin información.";          
        }
      },
      error: error => {
        this.spinner.hide();
        this.haveResponde = false;
        this.haveDataToShow = false;
        this.showMessageDialog("Error", "Ocurrió un error al consultar.", "Aceptar", "", true, 3, this.matDialog, (_: any) => { });
      }
    });
  }

  private calcularDiferenciaDias(fechaInicio: string | Date): string {
    const inicio = new Date(fechaInicio);
    const hoy = new Date();

    let años = hoy.getFullYear() - inicio.getFullYear();
    let meses = hoy.getMonth() - inicio.getMonth();
    let dias = hoy.getDate() - inicio.getDate();

    if (dias < 0) {
      meses--;
      const ultimoDiaMesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0).getDate();
      dias += ultimoDiaMesAnterior;
    }

    if (meses < 0) {
      años--;
      meses += 12;
    }

    
    if (años === 0 && meses === 0 && dias > 0) {  
      return `${dias} día${dias !== 1 ? 's' : ''}`;
    }

    if (años === 0 && meses > 0 && dias > 0) {
      return `${meses} mes${meses !== 1 ? 'es' : ''} y ${dias} día${dias !== 1 ? 's' : ''}`;
    }

    if (años > 0 && meses > 0 && dias > 0) {
      return `${años} año${años !== 1 ? 's' : ''}, ${meses} mes${meses !== 1 ? 'es' : ''} y ${dias} día${dias !== 1 ? 's' : ''}`;
    }

    
    if (años > 0 && meses === 0 && dias === 0) return `${años} año${años !== 1 ? 's' : ''}`;
    if (años === 0 && meses > 0 && dias === 0) return `${meses} mes${meses !== 1 ? 'es' : ''}`;
    if (años === 0 && meses === 0 && dias === 0) return `0 días`;

    
    if (años > 0 && meses > 0 && dias === 0)
      return `${años} año${años !== 1 ? 's' : ''} y ${meses} mes${meses !== 1 ? 'es' : ''}`;
    if (años > 0 && meses === 0 && dias > 0)
      return `${años} año${años !== 1 ? 's' : ''} y ${dias} día${dias !== 1 ? 's' : ''}`;

    return `${años} año${años !== 1 ? 's' : ''}, ${meses} mes${meses !== 1 ? 'es' : ''} y ${dias} día${dias !== 1 ? 's' : ''}`;

  }

  displayedColumns: string[] = this.columnOptions
  .filter(c => c.selected)
  .map(c => c.key);

  selectedColumns = this.columnOptions
  .filter(c => c.selected)
  .map(c => c.key); 

  toggleColumn(col: any) {
    col.selected = !col.selected;

    this.selectedColumns = this.columnOptions
      .filter(c => c.selected)
      .map(c => c.key);

    this.displayedColumns = this.columnOptions
      .filter(c => c.selected)
      .map(c => c.key);
  }

  onSelectOption(event: any, col: any) {
    const selected = event.source.selected;

    if (col.key === 'todas') {
      this.columnOptions.forEach(c => {
        if (c.key !== 'todas') c.selected = selected;
      });

      this.mandatoryColumns.forEach(m => {
        const mandatoryCol = this.columnOptions.find(c => c.key === m);
        if (mandatoryCol) mandatoryCol.selected = true;
      });

      const selectedKeys = this.columnOptions
        .filter(c => c.selected && c.key !== 'todas')
        .map(c => c.key);

      this.displayedColumns = [...selectedKeys];
      this.attrData = [...selectedKeys];

      this.namesColumns = this.columnOptions
        .filter(c => c.selected && c.key !== 'todas')
        .map(c => c.label);

      return;
    }

    if (this.mandatoryColumns.includes(col.key)) {
      col.selected = true;
      event.source.selected = true;
      return;
    }

    col.selected = selected;

    let selectedKeys = this.columnOptions
      .filter(c => c.selected)
      .map(c => c.key);

    this.displayedColumns = [...selectedKeys];
    this.attrData = [...selectedKeys];

    this.namesColumns = this.columnOptions
      .filter(c => selectedKeys.includes(c.key))
      .map(c => c.label);
  }

  clear(){
    this.frmMain.reset();
    this.frmContratos.reset();
    this.frmActivos.reset();    
    this.haveDataToShow = false;
    this.generalMessage = "";
  }

  exportData(){
    let json: any = {};
    let SheetNames: any[] = ["reporte"]; //paginas
    const keys = {
      reporte: this.attrDataExport.reduce((acc, key, index) => {
        acc[key] = this.namesColumnsExport[index];
        return acc;
      }, {} as Record<string, string>)
    };    
    let Keys:any = keys;
    json["reporte"] = this.jsonData;

    let Sheets:any = {};
    let i = 0;

    for (let key in Keys) {          
      const sheet = SheetNames[i]; 
        if (json[key] == null) {
          Sheets[sheet] = XLSX.utils.json_to_sheet([]);
        } else {
            let array = (<Array<any>> json[key]).map(dt => {
            let data:any = {}
            for ( let k in Keys[key]){
                data[Keys[key][k]] = dt[k]
            }
            return data;
            });
            Sheets[sheet] = XLSX.utils.json_to_sheet(array);      
        }
        i++;
    }

    const workbook: XLSX.WorkBook = {
        Sheets: Sheets,
        SheetNames: SheetNames
    };

    const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    // Call method buffer and fileName
    this.saveAsExcel(excelBuffer, this.reporteSeleccionadoName);
  }

  private saveAsExcel(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(
        data,
        "Reporte "+fileName + EXCEL_EXT
    );
}

  private intentos = 0;
  private maxIntentos = 5;
  loadParametersRecursive() {
    this.spinner.show();
    // Este observable controlará las llamadas recursivas
    of(null).pipe(
      concatMap(() => {
        if (this.intentos < this.maxIntentos) {
          this.intentos++;          
          return this.poblacionService.loadGeneralParameters(this.intentos); // Hacer la llamada HTTP
        } else {
          this.spinner.hide();
          this.intentos = 0;
          return of(null); // Finalizar cuando se alcancen los 5 intentos
        }
      }),
      concatMap(response => {
        if (this.intentos <= this.maxIntentos) {
          this.jsonRespuesta = response;
          if (this.jsonRespuesta.data.length != 0) {
            switch(this.intentos){
              case 1:
                this.parentescoData = this.jsonRespuesta.data;
                break;
              case 2:
                this.generoData = this.jsonRespuesta.data;
                break;
              case 3:
                this.programaData = this.jsonRespuesta.data;
                break;
              case 4:
                this.edadCarteraData = this.jsonRespuesta.data;
                break;
              case 5:
                this.rangoEdadData = this.jsonRespuesta.data;
                break;            
            }
          }else{
            this.intentos = 0;
          }
          return of(this.loadParametersRecursive()); // Volver a llamar recursivamente
        } else {
          return of(null);
        }
      })
    ).subscribe();
  }

  get getControlContratos(): { [key: string]: AbstractControl } {
    return this.frmContratos.controls;
  }
  get getControlActivos(): { [key: string]: AbstractControl } {
    return this.frmActivos.controls;
  }

  disableArrowKeys(event: KeyboardEvent) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }
  deleteSpaceAsesor(identification: string): string {
    const parts = identification.split('.');
    return parts.length > 1 ? parts[1].trim() : '';
  }
}

export function noSpacesValidator(control: AbstractControl): ValidationErrors | null {
  const hasSpaces = (control.value || '').includes(' ');
  return hasSpaces ? { noSpaces: true } : null;
}